import { FC } from "react";
import { ExamMode, ExamQuiz } from "../../../../types/exam";
import styles from "./index.module.scss";
import ExamSingleChoiceComp from "./single-choice";

interface ExamQuizProps {
  visible: boolean;
  dataSource: ExamQuiz;
  logId: number;
  index: number;
  mode: ExamMode;
  examSubmitted: boolean;
  onChange: () => void;
  // 答案正确
  onRight: () => void;
}

const Quiz: FC<ExamQuizProps> = ({
  visible,
  dataSource,
  logId,
  index,
  mode,
  examSubmitted,
  onChange,
  onRight,
}) => {
  if (!visible) return null;

  if (dataSource.question_type === "single_choice") {
    return (
      <ExamSingleChoiceComp
        dataSource={dataSource}
        logId={logId}
        index={index}
        mode={mode}
        examSubmitted={examSubmitted}
        onChange={onChange}
        onRight={onRight}
      />
    );
  }

  return <div className={styles.quiz}>未定义题型</div>;
};

export default Quiz;
